"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setUserSettingsPsychrometricChartMutation = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.setUserSettingsPsychrometricChartMutation = (0, graphql_tag_1.default) `
  mutation SetUserSettingsPsychrometricChart(
    $newsettings: UserSettingsPsychrometricChartInputType!
  ) {
    setUserSettingsPsychrometricChart(
      userSettingsPsychrometricChart: $newsettings
    ) {
      id
    }
  }
`;
//# sourceMappingURL=set-user-settings-psychrometric-chart.js.map